import { useAuth } from "@clerk/clerk-react";
import { useMemo } from "react";
import { AdminApi } from "./api.js";

export function useAdminApiAuthed(): AdminApi {
  const { getToken } = useAuth();
  return useMemo(
    () =>
      new AdminApi(async () => {
        const token = await getToken();
        return token ?? null;
      }),
    [getToken],
  );
}

export function useAdminApiDev(): AdminApi {
  return useMemo(() => new AdminApi(async () => "dev_admin_dev_user"), []);
}
